const winston = require('winston');
const { getLogContext } = require('./logContext');
const { LOG_SEVERITY } = require('../domain/logger.constants');

let serverLoggerInstance = null;

function createWinstonLogger() {
  return winston.createLogger({
    level: process.env.LOG_LEVEL || 'info',
    format: winston.format.combine(
      winston.format.timestamp(),
      winston.format.errors({ stack: true }),
      winston.format.json(),
    ),
    transports: [new winston.transports.Console()],
    exitOnError: false,
  });
}

function createServerLogger() {
  const winstonLogger = createWinstonLogger();

  const log = (message, metadata, severity) => {
    const context = getLogContext();
    const enrichedMetadata = {
      correlation_id: context?.correlationId,
      ...metadata,
    };

    winstonLogger[severity](message, enrichedMetadata);
  };

  return {
    log: (message, metadata = {}) => log(message, metadata, LOG_SEVERITY.INFO),
    debug: (message, metadata = {}) => log(message, metadata, LOG_SEVERITY.DEBUG),
    info: (message, metadata = {}) => log(message, metadata, LOG_SEVERITY.INFO),
    warn: (message, metadata = {}) => log(message, metadata, LOG_SEVERITY.WARN),
    error: (message, metadata = {}) => log(message, metadata, LOG_SEVERITY.ERROR),
  };
}

function getServerLogger() {
  if (!serverLoggerInstance) {
    serverLoggerInstance = createServerLogger();
  }
  return serverLoggerInstance;
}

module.exports = {
  getServerLogger,
};
